import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, Renderer2 } from '@angular/core';
import { environment } from '@env-properties/environment';
import { UniversalService } from './universal.service';

@Injectable({
  providedIn: 'root'
})
export class LazyInjectorService {
  title = 'dyncss';
  private style: HTMLLinkElement;
  private cssFile: string;
  private themeCSSID: string;
  private loadedScripts: Set<string> = new Set();

  constructor(public universalService:UniversalService,
    @Inject(DOCUMENT) private document: Document
  ) { }

  lazyInjectCss(theme, renderer2: Renderer2) {
    this.themeCSSID = theme;
    this.cssFile = `${theme}.css` +  '?v=' + environment.appVersion;
    this.removeExistingThemeStyle(renderer2, this.themeCSSID);
    
    // Create a link element via Angular's renderer to avoid SSR troubles
    this.style = renderer2.createElement('link') as HTMLLinkElement;

    // Set type of the link item and path to the css file
    renderer2.setProperty(this.style, 'rel', 'stylesheet');
    renderer2.setProperty(this.style, 'href', this.cssFile);
    renderer2.setProperty(this.style, 'id', this.themeCSSID);

    // Add the style to the head section
    renderer2.appendChild(this.document.head, this.style);
  }

  removeExistingThemeStyle(renderer2: Renderer2, themeCSSID: string) {
    const themeIDHTMlElem = this.document.getElementById(themeCSSID);
    if (themeIDHTMlElem) {
      renderer2.removeChild(this.document.head, themeIDHTMlElem);
    }
  }



  LazyInjectJSScripts(script){
    var scriptId = "js_"+script;
    var scriptName =  script + '.js' + '?v=' + environment.appVersion;
    var scriptTag = this.document.createElement('script');
    scriptTag.setAttribute('src', scriptName);
    if(this.universalService.activeRepo == 'enterprise' && scriptName == 'croppie.js'){
      scriptTag.setAttribute('type', 'application/json');
    }else{
      scriptTag.setAttribute('type', 'text/javascript');
    }
    scriptTag.setAttribute('id', scriptId);
    if(!this.document.getElementById(scriptId)){
      this.document.body.appendChild(scriptTag);
    }
  }

  //It's specific to player, as player was giving error on low speed network. Here, post loading we initiate video setup and load.
  LazyInjectVideoPlayerScript(script: string): Promise<void> {
    var scriptId = "js_"+script;
    var scriptName =  script + '.js';    
    return new Promise((resolve, reject) => {
      if (this.loadedScripts.has(script)) {
        resolve(); // Script is already there, then resolve
        return;
      }
      const scriptTag = this.document.createElement('script');
      scriptTag.setAttribute('src', scriptName);
      scriptTag.setAttribute('type', 'text/javascript');
      scriptTag.setAttribute('async', "true");
      scriptTag.onload = () => {
        this.loadedScripts.add(script); // adding script in set to keep track if already there
        resolve();
      };
      scriptTag.onerror = () => reject(`Error loading script: ${script}`);
      document.body.appendChild(scriptTag);
    });
  }
}
